var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { generateReducer, } from "../generators/generator.reducer";
import { addEnabledAccountFailed, addEnabledAccountStart, addEnabledAccountSucceeded, getEnabledAccountsCountFailed, getEnabledAccountsCountStart, getEnabledAccountsCountSucceeded, getEnabledAccountsFailed, getEnabledAccountsStart, getEnabledAccountsSucceeded, removeEnabledAccountFailed, removeEnabledAccountStart, removeEnabledAccountSucceeded, useEnabledAccountFailed, useEnabledAccountStart, useEnabledAccountSucceeded, } from "./enabledAccount.actions";
import { GENERATOR_PARAMS } from "./enabledAccount.constants";
var getExtraDefaultState = function () { return ({}); };
var _reducer = generateReducer(GENERATOR_PARAMS, getExtraDefaultState);
var reducer = _reducer;
reducer.on(getEnabledAccountsStart.type, function (state) { return (__assign(__assign({}, state), { isFetchingEnabledAccounts: true, fetchEnabledAccountsError: undefined })); });
reducer.on(getEnabledAccountsSucceeded.type, function (state, _a) {
    var result = _a.result;
    return (__assign(__assign({}, state), { isFetchingEnabledAccounts: false, fetchEnabledAccountsError: undefined, enabledAccounts: result }));
});
reducer.on(getEnabledAccountsFailed.type, function (state, _a) {
    var error = _a.error;
    return (__assign(__assign({}, state), { isFetchingEnabledAccounts: false, fetchEnabledAccountsError: error }));
});
// The in-flight flag is what lets a caller skip a fetch it has already started. The
// generated count reducer sets it on `getCountStartNoThrottle` only, which no saga in this
// module dispatches, so the count needs its own handlers (DEV-2884).
reducer.on(getEnabledAccountsCountStart.type, function (state) { return (__assign(__assign({}, state), { isFetchingEnabledAccountsCount: true, fetchEnabledAccountsCountError: undefined })); });
reducer.on(getEnabledAccountsCountSucceeded.type, function (state, _a) {
    var count = _a.count;
    return (__assign(__assign({}, state), { isFetchingEnabledAccountsCount: false, fetchEnabledAccountsCountError: undefined, enabledAccountsCount: count }));
});
reducer.on(getEnabledAccountsCountFailed.type, function (state, _a) {
    var error = _a.error;
    return (__assign(__assign({}, state), { isFetchingEnabledAccountsCount: false, fetchEnabledAccountsCountError: error }));
});
reducer.on(addEnabledAccountStart.type, function (state) { return (__assign(__assign({}, state), { isAdding: true, addError: undefined })); });
reducer.on(addEnabledAccountSucceeded.type, function (state) { return (__assign(__assign({}, state), { isAdding: false, addError: undefined })); });
reducer.on(addEnabledAccountFailed.type, function (state, _a) {
    var error = _a.error;
    return (__assign(__assign({}, state), { isAdding: false, addError: error }));
});
reducer.on(removeEnabledAccountStart.type, function (state) { return (__assign(__assign({}, state), { isRemoving: true, removeError: undefined })); });
reducer.on(removeEnabledAccountSucceeded.type, function (state) { return (__assign(__assign({}, state), { isRemoving: false, removeError: undefined })); });
reducer.on(removeEnabledAccountFailed.type, function (state, _a) {
    var error = _a.error;
    return (__assign(__assign({}, state), { isRemoving: false, removeError: error }));
});
reducer.on(useEnabledAccountStart.type, function (state) { return (__assign(__assign({}, state), { isUsing: true, useError: undefined })); });
reducer.on(useEnabledAccountSucceeded.type, function (state) { return (__assign(__assign({}, state), { isUsing: false, useError: undefined })); });
reducer.on(useEnabledAccountFailed.type, function (state, _a) {
    var error = _a.error;
    return (__assign(__assign({}, state), { isUsing: false, useError: error }));
});
// eslint-disable-next-line import/no-default-export
export default reducer;
